const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-up",
    width: 16,
    height: 16,
    viewBox: "0 0 4.233 4.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(73.405 -1.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7841-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9547-2",
    d: "m -73.009152,4.8025217 1.434153,-1.320847 c 0.17338,-0.161425 0.396279,-0.164346 0.577234,0.0041 l 1.428841,1.316715",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.264583,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "markers fill stroke"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.e28b9087f4d54c47fb06c7c0dc169615.svg";
export { ForwardRef as ReactComponent };